import { FinancialTransactionModel } from "domains/order/agreggates/payment/FinancialTransactionModel";
import { IOfflineCardData } from "modules/cardReader/domain/models/IOfflineCardData";
import { Payment } from "modules/order/domain/models/Payment";
import { TransactionType } from "modules/payment/domain/models/TransactionType";




type IDeviceInfo = {
  serialNumber: string;
  appVersion: string;
  timestamp: string;
};

const getDeviceInfo = async (): Promise<IDeviceInfo | null> => {
  const deviceInfo = await window.RNBridge.callNative("getDeviceInfo");
  return deviceInfo;
}

const printBase64 = async (base64: string) => {
  const result = await window.RNBridge.callNative("printBase64", base64);
  return result;
}

// openMsitefActions: async (params?: {config?: Partial<CommonOptions>}) => Promise<void>
const openMsitefActions = async (params?: { config?: SitefMetadata }): Promise<void> => {
  const result = await window.RNBridge.callNative("openMsitefActions", params);
  return result;
}

const printString = async (text: string) => {
  console.log("printString: ", text);
  const result = await window.RNBridge.callNative("printString", { text });
  return result;
}



export enum TypeTransaction {
  DEBIT = 'DEBIT',
  CREDIT = 'CREDIT',
}
// export type TxParams = {
//   amount: number;
//   typeTransaction?: TypeTransaction;
//   creditType?: CreditType;
//   installment?: number;
//   isTyped?: boolean;
//   isPreAuth?: boolean;
//   interestType?: InterestType;
//   printReceipt?: boolean;
// };


export interface SitefMetadata {
  tokenRegistroTls: string;
  comExterna?: string;
  empresaSitef: string;
  enderecoSitef: string;
  CNPJ_CPF: string;
  cnpj_automacao?: string;
  dadosSubAdqui?: string;
  terminalSitef?: string;
}
interface ITransactionParamCommon {
  amount: number;
  typeTransaction: TransactionType;
  token: string;
  printReceipt?: boolean;
}

interface ITransactionParamDirectpin extends ITransactionParamCommon {
  aquirer: 'directpin';
}
interface ITransactionParamMsitef extends ITransactionParamCommon {
  aquirer: 'msitef';
  metadata?: SitefMetadata;

}

export type ITransactionParams = ITransactionParamDirectpin | ITransactionParamMsitef;


export type InitResponse = {
  type: string;
  result: boolean;
  message: string;
};

export type TransactionResponse = Payment

export type ReadCardResponse = {
  uid: string;
  success?: boolean;
  message?: string;
  offlineCardData?: IOfflineCardData;
  isClosed?: boolean;
};




export interface FacialRecognitionResponse {
  success: boolean;
  message: string;
  data: any;
}


const initPayment = async (token: string): Promise<InitResponse> => {
  const result = await window.RNBridge.callNative("initPayment", token);
  return result;
}

const transaction = async (params: ITransactionParams): Promise<TransactionResponse> => {
  const result = await window.RNBridge.callNative("transaction", params);
  return result;
}

const readCard = async (onlyUid?: boolean, disableBeep?: boolean): Promise<ReadCardResponse> => {
  const result = await window.RNBridge.callNative("readCard", { onlyTag: onlyUid ?? false, disableBeep: disableBeep ?? false });
  console.log("readCard", result);
  return result;  
}

const abortReadCard = async (): Promise<void> => {
  await window.RNBridge.callNative("abortReadCard");
}

const addListenerOnCardRemoved = (callback: () => void): void => {
  window.RNBridge.register("onCardRemovedCallback", callback);
}

const writeOfflineBalance = async (tag: string, value: number): Promise<void> => {
  await window.RNBridge.callNative("writeBalance", { tag, balance: value });
}


export const writeOfflineCard = async (
  data: IOfflineCardData,
): Promise<{
  success: boolean;
  message: string;
}> => {
  console.log("[ReactNativeBridge] writeOfflineCard", data);
  const result = await window.RNBridge.callNative("writeCard", { ...data });
  return result;
}



export { getDeviceInfo, printBase64, printString, initPayment, transaction, readCard, abortReadCard, openMsitefActions, addListenerOnCardRemoved, writeOfflineBalance };

